package com.example.readingnotes.data.repository

import com.example.readingnotes.data.remote.api.ApiClient
import com.example.readingnotes.data.remote.dto.CreateCommentRequestDto
import com.example.readingnotes.data.remote.mapper.toDomain
import com.example.readingnotes.domain.model.Comment
import com.example.readingnotes.domain.repository.CommentRepository
import com.example.readingnotes.util.Result

class CommentRepositoryImpl(
    private val apiClient: ApiClient,
) : CommentRepository {
    override suspend fun getComments(postId: Int): Result<List<Comment>> =
        try {
            val response = apiClient.getComments(postId)
            Result.success(response.toDomain())
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun createComment(
        postId: Int,
        authorName: String?,
        content: String,
    ): Result<Comment> =
        try {
            val response =
                apiClient.createComment(
                    postId,
                    CreateCommentRequestDto(authorName, content),
                )
            Result.success(response.toDomain())
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun deleteComment(id: Int, totpCode: String?): Result<Unit> =
        try {
            apiClient.deleteComment(id, totpCode)
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }

    override suspend fun bulkDeleteComments(ids: List<Int>, totpCode: String?): Result<Int> =
        try {
            val response = apiClient.bulkDeleteComments(ids, totpCode)
            Result.success(response.deletedCount)
        } catch (e: Exception) {
            Result.failure(e)
        }
}
